module.exports = __webpack_public_path__ + "assets/img/end_photo.eba82c58.jpg";